import { GetterTree } from 'vuex';
import { UserProfile, UsersState } from './models';
import { RootState } from '@/store';

export enum Getters {
  LOADED = 'LOADED',
  LOADING = 'LOADING',
  USER_PROFILE = 'USER_PROFILE',
}

export const getters: GetterTree<UsersState, RootState> = {

  [Getters.LOADED]({ loaded }): boolean {
    return loaded;
  },

  [Getters.LOADING]({ loading }): boolean {
    return loading;
  },

  [Getters.USER_PROFILE]({ currentUser }): UserProfile | undefined {
    return currentUser;
  },
};
